export default "/images/50x50.png"